// @ts-strict-ignore
import { Body } from "components/parts/Typography";
import styled from "styled-components";

export const BlogPostContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColors.primary};
  border-radius: 8px;
  background-color: white;
  // Whole post container should be clickable
  cursor: pointer;
  position: relative;
  padding-bottom: 60px;
  ${({ active }) =>
    active &&
    `
      filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.08));
  `}
`;

export const PostImgContainer = styled.div`
  width: inherit;
  border-radius: 8px 8px 0 0;
  img {
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${({ theme }) => theme.borderColors.primary};
    width: 100%;
    height: auto;
  }
`;

export const PostDetailsContainer = styled.div`
  margin: 16px;
`;

export const PostDetailsInner = styled.div`
  display: flex;
`;

export const PostAuthorDetails = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  position: absolute;
  bottom: 0;
  ${({ active }) =>
    active &&
    `
    text-decoration: underline;
    cursor: pointer;
    p {
      color: unset;
    }
  `}
`;

export const PostTitleLink = styled(Body).attrs({ size: "md", semiBold: true })`
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 48px;
`;

export const PostAuthorLink = styled(Body).attrs({ size: "sm" })``;

export const PostIntro = styled(Body).attrs({ size: "sm" })`
  ${({ applyEllpisis }) =>
    applyEllpisis &&
    `
display: -webkit-box;
max-width: 100%;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;
overflow: hidden;
`}
`;
